module.exports = __webpack_public_path__ + "img/5a.a23f53e6.jpg";